module.exports = __webpack_public_path__ + "static/Forager7-e24c7ddbb2caca9ce442a69c49aae4a3.webp";